import { connect } from "react-redux";
import OvAccountsView from "./OvAccountsView";

const mapStateToProps = (state, ownProps) => {
  const series = state.overview.accountSeries.data;
  const accounts = state.entities.accounts;
  const filters = state.overview.filters;

  const filteredData = Object.keys(series)
    .map(id => {
      let name = accounts[id] ? accounts[id]["name"] : id.toString();
      name = `${id}|${name}`;
      return { ...series[id], name, id };
    })
    .filter(el => {
      if (filters.excludeZeroCompute && el.instance_cost === 0) {
        return false;
      }

      if(filters.minStorageCostEnabled && el.storage_cost < filters.minStorageCost) {
        return false;
      }

      return el.name;
    })
    .sort(
      (a, b) => a.name.split("|")[1].toLowerCase().localeCompare(b.name.split("|")[1].toLowerCase())
    ).reverse();

  return {
    data: filteredData,
    filterState: filters,
    loading: state.overview.accountSeries.loading,
    monitoringMode: state.ui.focused,
  };
};

const OvAccountsViewContainer = connect(mapStateToProps)(OvAccountsView);

export default OvAccountsViewContainer;


// WEBPACK FOOTER //
// ./src/OvAccountsViewContainer.js